import React, { useEffect, useState } from 'react';
import { getTicketDetailAPI } from '@/service/ticketService';
import { API } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import { Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import Constant from '@/common/constant/Constant';
import { trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function RenderTagItemMultiChoice({ item, indeterminate, name, id, status, handleOnChange, isTagMaster }) {
    // Re-render when the translation dictionary loads/extends so trLabel() text updates.
    useTranslationSubscription();
    const [itemLabel , setItemLabel] = useState(name);
    const [loading , setLoading] = useState(false);

    // Tag item name is group 2 -> trLabel. Keep original (group 3) for:
    // - tag master (label is a user-created ticket title)
    // - project item in BUSINESS_APP_USE_RANGE (label is a project name)
    const getDisplayLabel = () => {
        if (isTagMaster || Utils.getPrefixOfId(item?.id) === Constant.ID_PREFIX.PROJECT) {
            return itemLabel;
        }
        return trLabel(itemLabel);
    };
    
    useEffect(() => {
        if (!isTagMaster) return;
        if(!itemLabel) {
            setLoading(true);
            getTicketDetailAPI(API, id).then((ticketDetailResult) => {
                let detailTicket = ticketDetailResult.detailTicket;
                let titketTitle =  Utils.getTitle(detailTicket?.settingTitle);
                setLoading(false);
                setItemLabel(titketTitle);
            })
        }
    }, [item]);

    if (loading) {
        return (
            <FormControlLabel
                control={
                    <Checkbox
                        className="hello"
                        checked={status === 'checked'}
                        indeterminate={indeterminate}
                        onChange={e => handleOnChange(item)}
                    />
                }
                label={<Skeleton variant="text" width={200} height={30} />}
                className={`checkbox-item-of-tag-field label-item-name`}
                id={id}
                key={`${id}-tag-item-loading`}
            />
        )
    }

    const displayLabel = getDisplayLabel();

    return (
        <Tooltip title={`${displayLabel}`} arrow= {false} placement = "top-center">
            <p>
            <FormControlLabel
                control={
                    <Checkbox
                        className="hello"
                        checked={status === 'checked'}
                        indeterminate={indeterminate}
                        onChange={e => handleOnChange(item)}
                    />
                }
                label={`${displayLabel}`}
                className={`checkbox-item-of-tag-field label-item-name`}
                id={id}
                key={`${id}-tag-item`}
            />
            </p>
        </Tooltip>
    );
}